import { ImplicitCallback } from '@okta/okta-react/dist/index';

export const oktaCallback = [
    {
        path: '/callback',
        component: ImplicitCallback,
    },
];
